import React, { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = ({ custID }) => {
    // console.log('cstID-reg :', custID);

    const [customer, setCustomer] = useState([]);
    const [customerById, setCustomerById] = useState({});
    const [product, setProduct] = useState([]);
    const [moduleName, setModuleName] = useState([]);
    const [customer_Id, setCustomer_Id] = useState(''); // State to store checked module IDs
    const [errors, setErrors] = useState({}); // Store validation errors
    const [selectedCustomerId, setSelectedCustomerId] = useState(custID || '');

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        customer_product: '',
        product: '',
        module_Id: [],
        customer_name: '',
        customer_code: '',
        customer_email: '',
        customer_phone: '',
        no_of_customer: '',
        data_size: '',
        contact_name: '',
        contact_phone: '',
        contact_email: '',
        gst_no: '',
        no_of_users: '',
        address: '',
        city: '',
        state: '',
        billing: '',
        renewal_fee: '',
        fromDate: new Date().toISOString().split('T')[0],
        toDate: '',
        product_key: ''
    });

    const fetchCustomer = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Customer/GetCustomerNames`);

            if (!response.ok) {
                console.log('something went wrong!');
                return;
            }

            const data = await response.json();
            // console.log('customer-list :', data.length);
            setCustomer(data);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchProduct = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Customer/GetProductNames`);

            if (!response.ok) {
                console.log('something went wrong!');
                return;
            }

            const data = await response.json();
            // console.log('product-list :', data);
            setProduct(data);
        } catch (error) {
            console.log(error);
        }
    };

    // Update formData when customerById changes
    useEffect(() => {
        if (customerById) {
            // console.log("Updating formData with:", customerById); // Debugging log

            setCustomer_Id(customerById.mcrId || '');

            // Find product name based on mcrMpId
            const selectedProduct = product.find(prod => prod.mpId === customerById.mcrMpId);

            if (selectedProduct) {
                moduleNamesByproduct(selectedProduct.mpProductName || []);
            } else {
                setModuleName([]); // Reset module list if no product is selected
            }

            setFormData({
                product: selectedProduct ? selectedProduct.mpId : "", // Store product ID
                module_Id: customerById.moduleIds || [],
                customer_name: customerById.mcrCustomerName || "",
                // customer_code: customerById.mcrCustomerCode || "",
                customer_email: customerById.mcrCustomerEmail || "",
                customer_phone: customerById.mcrCustomerTelephoneNo || "",
                no_of_customer: customerById.mcrNumberOfCustomers || "",
                data_size: customerById.mcrDataSize || "",
                contact_name: customerById.mcrContactPersonName || "",
                contact_phone: customerById.mcrContactPersonPhoneNo || "",
                contact_email: customerById.mcrContactPersonEmail || "",
                gst_no: customerById.mcrGstno || "",
                no_of_users: customerById.mcrNumberOfUsers || "",
                address: customerById.mcrAddress || "",
                city: customerById.mcrCity || "",
                state: customerById.mcrState || "",
                billing: customerById.mcrBillingFrequency || "",
                renewal_fee: customerById.mcrRnwlFee || "",
                fromDate: customerById.mcrFromDate || new Date().toISOString().split('T')[0],
                toDate: customerById.mcrToDate || "",
                // product_key: customerById.mcrProductKey || "",
            });
        }
    }, [customerById, product]); // Runs when new customer data arrives

    const fetchCustomerById = async (id) => {
        try {
            setCustomerById(null); // Reset state before fetching new data

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Customer/GetCustomerDetailsByName?CustomerId=${id}`);

            if (!response.ok) {
                console.error("API request failed.");
                return;
            }

            const data = await response.json();
            // console.log("Received customer data:", data); // Debugging log

            setCustomerById({ ...data }); // Ensure React detects the change
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    };

    const handleClickCustomerData = (id) => {
        // console.log("id :", id);
        setSelectedCustomerId(id); // Update selected customer ID

        if (!id) {
            console.log("Customer ID is required.");
            setCustomerById({});
            return;
        }

        fetchCustomerById(id);
    };

    useEffect(() => {
        fetchCustomer();
        fetchProduct();
        handleClickCustomerData(custID);
    }, [custID]);

    const moduleNamesByproduct = async (pname) => {
        // console.log('p-name :', pname)
        if (!pname) {
            // console.log('Product name is required');
            setModuleName([]); // Reset modules if no product is selected
            return;
        }

        const apiUrl = `${process.env.REACT_APP_API_URL}/api/Customer/GetModulesByProductName?productname=${pname}`;
        // console.log('Fetching modules for:', pname);
        // console.log('API URL:', apiUrl);

        try {
            const response = await fetch(apiUrl);

            if (!response.ok) {
                console.log('Something went wrong!', response.statusText);
                return;
            }

            const data = await response.json();
            // console.log('Module list response:', data);
            setModuleName(data.moduleNames || []);

        } catch (error) {
            console.log(error);    
        }
    };

    // Handle checkbox change
    const handleCheckboxChange = (e, moduleId) => {
        const isChecked = e.target.checked;
        setFormData(prev => ({
            ...prev,
            module_Id: Array.isArray(prev.module_Id)
                ? (isChecked
                    ? [...prev.module_Id, moduleId]  // Add ID if checked
                    : prev.module_Id.filter(id => id !== moduleId)) // Remove ID if unchecked
                : [moduleId] // Ensure module_Id is always an array
        }));
    };


    // Function to calculate 'To Date' based on 'From Date' and 'Billing Frequency'
    const calculateToDate = (billingFrequency, fromDate) => {
        if (!billingFrequency || !fromDate) return ''; // Ensure both are present

        let fromDateObj = new Date(fromDate); // Parse the 'From Date'
        let toDateObj = new Date(fromDateObj); // Clone it for 'To Date' calculation

        // Calculate the 'To Date' based on the billing frequency
        switch (billingFrequency) {
            case '1':
                toDateObj.setMonth(toDateObj.getMonth() + 1);
                break;
            case '3':
                toDateObj.setMonth(toDateObj.getMonth() + 3);
                break;
            case '6':
                toDateObj.setMonth(toDateObj.getMonth() + 6);
                break;
            case '12':
                toDateObj.setFullYear(toDateObj.getFullYear() + 1);
                break;
            default:
                return ''; // No calculation if no billing frequency selected
        }

        // Return the 'To Date' in 'YYYY-MM-DD' format
        return toDateObj.toISOString().split('T')[0];
    };

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Update formData
        setFormData((prevData) => {
            const updatedData = { ...prevData, [name]: value };

            // Log form data after update for debugging
            console.log("Updated form data:", updatedData);

            // Calculate 'To Date' immediately if 'billing' or 'fromDate' changes
            if (name === 'billing' || name === 'fromDate') {
                const calculatedToDate = calculateToDate(updatedData.billing, updatedData.fromDate);
                updatedData.toDate = calculatedToDate; // Set the calculated 'toDate'
            }

            // Log the 'toDate' calculation for debugging
            console.log("Calculated toDate:", updatedData.toDate);

            return updatedData;
        });

        // Clear error for the current field when user types
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };


    const handleSubmit = async () => {
        // console.log('data-bind :', formData);
        let validationErrors = {};

        // // Validation logic
        if (!formData.product) validationErrors.product = 'Product is required.';

        // if (module_Id.length === 0) validationErrors.modules = 'At least one module must be selected.';

        if (!formData.customer_name) validationErrors.customer_name = 'Customer name is required.';

        // if (!formData.customer_code) validationErrors.customer_code = 'Customer code is required.';

        // Validate customer_email
        if (!formData.customer_email || formData.customer_email.trim() === '') {
            validationErrors.customer_email = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(formData.customer_email)) {
            validationErrors.customer_email = 'Please enter a valid email address.';
        }

        // Validate customer_phone
        if (!formData.customer_phone || formData.customer_phone.trim() === '') {
            validationErrors.customer_phone = 'Phone number is required.';
        } else if (!/^\d{10}$/.test(formData.customer_phone)) {
            validationErrors.customer_phone = 'Please enter a valid 10-digit phone number.';
        }

        if (!formData.data_size) validationErrors.data_size = 'Data size is required.';

        if (!formData.contact_name) validationErrors.contact_name = 'Contact name is required.';

        // Validate contact_phone
        if (!formData.contact_phone || formData.contact_phone.trim() === '') {
            validationErrors.contact_phone = 'Phone number is required.';
        } else if (!/^\d{10}$/.test(formData.contact_phone)) {
            validationErrors.contact_phone = 'Please enter a valid 10-digit phone number.';
        }

        if (!formData.no_of_customer) validationErrors.no_of_customer = 'No of customer is required.';

        // Validate contact_email
        if (!formData.contact_email || formData.contact_email.trim() === '') {
            validationErrors.contact_email = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(formData.contact_email)) {
            validationErrors.contact_email = 'Please enter a valid email address.';
        }

        if (!formData.gst_no) validationErrors.gst_no = 'GST number is required.';

        if (!formData.no_of_users) validationErrors.no_of_users = 'No of users is required.';

        if (!formData.address) validationErrors.address = 'Address is required.';

        if (!formData.city) validationErrors.city = 'City is required.';

        if (!formData.state) validationErrors.state = 'State is required.';

        if (!formData.billing) validationErrors.billing = 'billing month is required.';

        if (!formData.renewal_fee || isNaN(formData.renewal_fee))
            validationErrors.renewal_fee = 'Renewal fee must be a number.';

        if (!formData.fromDate) validationErrors.fromDate = 'from Date is required.';

        if (!formData.toDate) validationErrors.toDate = 'to Date is required.';

        // if (!formData.product_key) validationErrors.product_key = 'Product key is required.';

        // // If validation errors exist, update state and stop submission
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = {
            McrMpId: formData.product,
            MmMpId: formData.module_Id,
            mcrCustomerName: formData.customer_name,
            // mcrCustomerCode: formData.customer_code,
            mcrCustomerEmail: formData.customer_email,
            mcrCustomerTelephoneNo: formData.customer_phone,
            mcrContactPersonName: formData.contact_name,
            mcrContactPersonPhoneNo: formData.contact_phone,
            mcrContactPersonEmail: formData.contact_email,
            mcrGstno: formData.gst_no,
            mcrNumberOfUsers: formData.no_of_users,
            mcrAddress: formData.address,
            mcrCity: formData.city,
            mcrState: formData.state,
            mcrBillingFrequency: Number(formData.billing) || 0,
            mcrFromDate: formData.fromDate,
            mcrToDate: formData.toDate,
            mcrCreatedDate: formData.fromDate,
            mcrStatus: "A",
            // mcrProductKey: formData.product_key,
            mcrTstatus: "U",
            mcrRnwlFee: formData.renewal_fee,
            mcrDataSize: formData.data_size,
            mcrNumberOfCustomers: formData.no_of_customer
        };

        // console.log('post-data :', postData);

        try {
            const response = await fetch(customer_Id ? `${process.env.REACT_APP_API_URL}/api/Customer/UpdateCustomerDetails/${customer_Id}` :
                `${process.env.REACT_APP_API_URL}/api/Customer/AddCustomers`,
                {
                    method: customer_Id ? 'PUT' : 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(postData)
                });

            if (!response.ok) {
                console.log('Something went wrong!');
                toast.error('Update failed!');
                return;
            }

            const data = await response.json();
            // console.log('data :', data);
            toast.success(customer_Id ? 'User updated successfully!' : 'Registered successfully!');  // ✅ Show success toast
            // Delay navigation after the toast has been displayed
            setTimeout(() => {
                resetData();
                if(!customer_Id){
                    navigate('/');
                } else {
                    fetchCustomerById(customer_Id);
                    fetchCustomer();
                }
            }, 5000);  // 5000ms (5 seconds) delay to let the toast appear
        } catch (error) {
            console.log(error);
            toast.error('An error occurred!');
        }

    }

    const resetData = () => {
        setFormData({
            customer_product: '',
            product: '',
            module_Id: [],
            customer_name: '',
            customer_code: '',
            customer_email: '',
            customer_phone: '',
            no_of_customer: '',
            data_size: '',
            contact_name: '',
            contact_phone: '',
            contact_email: '',
            gst_no: '',
            no_of_users: '',
            address: '',
            city: '',
            state: '',
            billing: '',
            renewal_fee: '',
            fromDate: '',
            toDate: '',
            product_key: ''
        })
    }

    return (
        <>
            <div className="h-screen w-full grid grid-cols-1 lg:grid-cols-2 bg-green-100">
                {/* Left Side - Fixed Image */}
                <div className="hidden lg:block h-screen w-full bg-cover bg-center">
                    <div className="w-full max-h-screen flex items-center justify-center">
                        <img
                            src="/images/image04.png"
                            alt="Register-Image"
                            className="w-full h-full"
                            style={{
                                animation: 'upDown 2s ease-in-out infinite',
                            }}
                        />
                        <style jsx>{`
        @keyframes upDown {
            0%, 100% {
                transform: translateY(0);
            }
            50% {
                transform: translateY(-20px);
            }
        }
    `}</style>
                    </div>

                </div>

                {/* Right Side - Scrollable Form */}
                <div className="h-screen overflow-y-auto bg-gray-100">
                    <div className="w-full bg-white p-6 rounded shadow-md">
                        <div className="flex justify-center">
                            <h2 className="text-xl font-bold mb-6 text-center inline-block border-b-2 border-[#95B589] pb-1
          bg-gradient-to-br from-teal-400 via-blue-400 to-lime-500 text-transparent bg-clip-text"
                            >
                                {selectedCustomerId ? 'Update Customer' : 'Customer Registration'}
                            </h2>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-xs mb-4">
                            {/* Select Existing Customer */}
                            <div className="col-span-1">
                                <div className='mb-4'>
                                    <label className="mb-1 block font-bold">Existing Customer</label>
                                    <select
                                        className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                        required
                                        value={selectedCustomerId}
                                        onChange={(e) => handleClickCustomerData(e.target.value)}
                                    >
                                        <option value="">Select Existing Customer</option>
                                        {customer.map((cust, index) => (
                                            <option key={index} value={cust.mcrId}>
                                                {cust.mcrCustomerName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className='mb-4'>
                                    <label className="mb-1 block font-bold">Product</label>
                                    <select
                                        className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                        name="product"
                                        value={formData.product} // Reflect selected product ID
                                        onChange={(e) => {
                                            const selectedProductId = parseInt(e.target.value); // Convert value to integer
                                            const selectedProduct = product.find(prod => prod.mpId === selectedProductId);

                                            if (selectedProduct) {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    product: selectedProduct.mpId // Store the product ID
                                                }));
                                                moduleNamesByproduct(selectedProduct.mpProductName); // Fetch modules based on the product
                                            }
                                        }}
                                        required
                                    >
                                        <option value="">Select product</option>
                                        {product.map((prod) => (
                                            <option key={prod.mpId} value={prod.mpId}>
                                                {prod.mpProductName} {/* Display product name, but value is product ID */}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.product && <p className="text-red-500 text-xs mt-1">{errors.product}</p>}
                                </div>
                                <div className='mb-4'>
                                    <label className="mb-1 block font-bold">Customer Name</label>
                                    <input
                                        type="text"
                                        name="customer_name"
                                        value={formData.customer_name}
                                        onChange={(e) => { handleChange(e) }}
                                        placeholder='Enter customer name'
                                        className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                        required
                                    />
                                    {errors.customer_name && <p className="text-red-500 text-xs mt-1">{errors.customer_name}</p>}
                                </div>
                                {/* <div className='mb-4'>
                                    <label className="mb-1 block font-bold">Customer Code</label>
                                    <input
                                        type="text"
                                        name="customer_code"
                                        value={formData.customer_code}
                                        onChange={(e) => { handleChange(e) }}
                                        placeholder='Enter customer name'
                                        className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                        required
                                    />
                                    {errors.customer_code && <p className="text-red-500 text-xs mt-1">{errors.customer_code}</p>}
                                </div> */}
                            </div>

                            <div className="col-span-1 mt-10">
                                <h4 className="text-sm mb-2">Modules</h4>
                                {moduleName.length > 0 ? (
                                    <ul className="space-y-2">
                                        {moduleName.map((module) => (
                                            <li key={module.moduleId}>
                                                <label className="form-label flex items-center gap-2.5 text-nowrap">
                                                    <input
                                                        className="checkbox"
                                                        name="check"
                                                        type="checkbox"
                                                        value={module.moduleId}
                                                        checked={Array.isArray(formData.module_Id) && formData.module_Id.includes(module.moduleId)}
                                                        onChange={(e) => handleCheckboxChange(e, module.moduleId)}
                                                    />
                                                    {module.moduleName}
                                                </label>
                                            </li>
                                        ))}
                                        {errors.module_Id && <p className="text-red-500 text-xs mt-1">{errors.module_Id}</p>}
                                    </ul>
                                ) : (
                                    <p className="text-gray-500">No modules available.</p>
                                )}

                            </div>
                        </div>

                        <div className='grid grid-cols-1 lg:grid-cols-3 gap-5 text-xs mb-4'>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Email</label>
                                <input
                                    type="email"
                                    name="customer_email"
                                    value={formData.customer_email}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter customer name'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.customer_email && <p className="text-red-500 text-xs mt-1">{errors.customer_email}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Telephone No</label>
                                <input
                                    type="number"
                                    name="customer_phone"
                                    value={formData.customer_phone}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter customer name'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.customer_phone && <p className="text-red-500 text-xs mt-1">{errors.customer_phone}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Data Size (MB)</label>
                                <input
                                    type="number"
                                    name="data_size"
                                    value={formData.data_size}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter data size(MB)'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.data_size && <p className="text-red-500 text-xs mt-1">{errors.data_size}</p>}
                            </div>
                        </div>

                        <div className='grid grid-cols-1 lg:grid-cols-3 gap-5 text-xs mb-4'>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Contact Person Name</label>
                                <input
                                    type="text"
                                    name="contact_name"
                                    value={formData.contact_name}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter contact person name'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.contact_name && <p className="text-red-500 text-xs mt-1">{errors.contact_name}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Contact Phone No</label>
                                <input
                                    type="number"
                                    name="contact_phone"
                                    value={formData.contact_phone}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter contact phone no'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.contact_phone && <p className="text-red-500 text-xs mt-1">{errors.contact_phone}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">No. of Customers</label>
                                <input
                                    type="number"
                                    name="no_of_customer"
                                    value={formData.no_of_customer}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter no. of customers'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.no_of_customer && <p className="text-red-500 text-xs mt-1">{errors.no_of_customer}</p>}
                            </div>
                        </div>

                        <div className='grid grid-cols-1 lg:grid-cols-3 gap-5 text-xs mb-4'>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Contact Person Email</label>
                                <input
                                    type="email"
                                    name="contact_email"
                                    value={formData.contact_email}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter contact person email'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.contact_email && <p className="text-red-500 text-xs mt-1">{errors.contact_email}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">GST No.</label>
                                <input
                                    type="text"
                                    name="gst_no"
                                    value={formData.gst_no}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter GST number'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.gst_no && <p className="text-red-500 text-xs mt-1">{errors.gst_no}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">No. of Users</label>
                                <input
                                    type="number"
                                    name="no_of_users"
                                    value={formData.no_of_users}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter no. of users'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.no_of_users && <p className="text-red-500 text-xs mt-1">{errors.no_of_users}</p>}
                            </div>
                        </div>

                        <div className='grig grid-cols-1 text-xs mb-4'>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Address</label>
                                <input
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter Address'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.address && <p className="text-red-500 text-xs mt-1">{errors.address}</p>}
                            </div>
                        </div>

                        <div className='grid grid-cols-1 lg:grid-cols-2 gap-5 text-xs mb-4'>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">City</label>
                                <input
                                    type="text"
                                    name="city"
                                    value={formData.city}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter city'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.city && <p className="text-red-500 text-xs mt-1">{errors.city}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">State</label>
                                <input
                                    type="text"
                                    name="state"
                                    value={formData.state}
                                    onChange={(e) => { handleChange(e) }}
                                    placeholder='Enter state'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.state && <p className="text-red-500 text-xs mt-1">{errors.state}</p>}
                            </div>
                        </div>

                        <div className='grid grid-cols-1 lg:grid-cols-4 gap-5 text-xs mb-4'>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Billing Frequency</label>
                                <select
                                    name="billing"
                                    value={formData.billing}
                                    onChange={handleChange}
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                >
                                    <option value="">Select billing frequency</option>
                                    <option value={1}>Monthly</option>
                                    <option value={3}>Quarterly</option>
                                    <option value={6}>Half-yearly</option>
                                    <option value={12}>Yearly</option>
                                </select>
                                {errors.billing && <p className="text-red-500 text-xs mt-1">{errors.billing}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Renewal Fee</label>
                                <input
                                    type="number"
                                    name="renewal_fee"
                                    value={formData.renewal_fee}
                                    onChange={handleChange}
                                    placeholder='Enter renewal fee'
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    required
                                />
                                {errors.renewal_fee && <p className="text-red-500 text-xs mt-1">{errors.renewal_fee}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">From Date</label>
                                <input
                                    type="date"
                                    name="fromDate"
                                    value={formData.fromDate} // Display the current date here
                                    onChange={handleChange}
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    readOnly
                                    required
                                />
                                {errors.fromDate && <p className="text-red-500 text-xs mt-1">{errors.fromDate}</p>}
                            </div>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">To Date</label>
                                <input
                                    type="date"
                                    name="toDate"
                                    value={formData.toDate} // The calculated 'To Date'
                                    onChange={handleChange}
                                    className="border border-gray-400 outline-blue-500 p-1 block w-full rounded-xs"
                                    readOnly
                                    required
                                />
                                {errors.toDate && <p className="text-red-500 text-xs mt-1">{errors.toDate}</p>}
                            </div>
                        </div>

                        {/* <div className='grid grid-cols-1 lg:grid-cols-2 gap-5 text-xs mb-4'>
                            <div className="col-span-1">
                                <label className="mb-1 block font-bold">Product Key</label>
                                <div className="relative">
                                    <input
                                        type="password"
                                        name="product_key"
                                        value={formData.product_key}
                                        onChange={(e) => { handleChange(e) }}
                                        placeholder="Enter product key"
                                        className="outline-blue-500 w-full p-2 pr-10 border border-gray-400 rounded-xs"
                                        required
                                    />
                                    <FaKey className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
                                    {errors.product_key && <p className="text-red-500 text-xs mt-1">{errors.product_key}</p>}
                                </div>
                            </div>
                        </div> */}

                        <div className="flex gap-8">
                            <button
                                onClick={() => {
                                    navigate('/register');
                                    setSelectedCustomerId('');
                                }}
                                type="submit"
                                className="text-sm font-bold bg-blue-600 hover:bg-blue-700
 text-white py-3 rounded-md mt-4 w-full"
                            >
                                New
                            </button>
                            <button
                                type="submit"
                                className="text-sm font-bold bg-blue-600 hover:bg-blue-700
 text-white py-3 rounded-md mt-4 w-full"
                                onClick={handleSubmit}>
                                {selectedCustomerId ? "Update" : "Register"}
                            </button>
                            <button
                                type="submit"
                                className="text-sm font-bold bg-blue-600 hover:bg-blue-700
 text-white py-3 rounded-md mt-4 w-full"
                            >
                                History
                            </button>
                            <Link
                                to='/'
                                type="submit"
                                className="text-sm text-center font-bold bg-blue-600 hover:bg-blue-700
 text-white py-3 rounded-md mt-4 w-full"
                            >
                                Back
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </>
    );
};

export default Register;
